import Alert from "@mui/material/Alert";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { initials } from "~/auth/permissions";
import { COLORS } from "~/ui/tokens";

const PALETTE = ["#05bbe5", "#7e57c2", "#26a69a", "#ef6c00", "#5c6bc0", "#ec407a", "#8d6e63", "#43a047", "#546e7a", "#0288d1"];
export const avatarColor = (seed) => PALETTE[[...(seed || "")].reduce((n, ch) => n + ch.charCodeAt(0), 0) % PALETTE.length];

export function PersonAvatar({ name, email, size = 32 }) {
  return (
    <Avatar alt="" sx={{ width: size, height: size, fontSize: Math.round(size * 0.4), fontWeight: 700, bgcolor: avatarColor(email || name) }}>
      {initials(name, email)}
    </Avatar>
  );
}

// v3-matriz-empresas-vazio.png / -erro.png: círculo com ícone, título e texto.
export function EmptyState({ icon: Icon, title, text, action }) {
  return (
    <Box sx={{ textAlign: "center", py: 8, px: 2 }}>
      <Box sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: "#e0f5fb", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
        {Icon && <Icon sx={{ fontSize: 36, color: COLORS.primary }} aria-hidden />}
      </Box>
      <Typography sx={{ fontWeight: 600, color: COLORS.primary }}>{title}</Typography>
      <Typography variant="body2" sx={{ color: COLORS.muted, whiteSpace: "pre-line", mt: 0.5 }}>{text}</Typography>
      {action && <Box sx={{ mt: 2 }}>{action}</Box>}
    </Box>
  );
}

export function LoadErrorBanner({ message, onRetry }) {
  return (
    <Alert
      severity="error"
      sx={{ my: 2 }}
      action={onRetry && <Button color="inherit" size="small" onClick={onRetry}>TENTAR NOVAMENTE</Button>}
    >
      <b>Erro</b> — {message}
    </Alert>
  );
}
